module.exports = __webpack_public_path__ + "static/media/hydropurr-5.dc03c7be.jpg";